import React from 'react';
import PropTypes from 'prop-types';

import LabeledTextInput from 'components/consumer/LabeledTextInput';

const EmailField = ({
  value,
  error,
  label = 'Email',
  isTouched,
  handleChange,
  handleBlur,
  refField,
  ...props
}) => (
  <LabeledTextInput
    id="email"
    type="email"
    name="email_address"
    label={label}
    onChange={handleChange}
    onBlur={handleBlur}
    autoComplete="email"
    value={value}
    data-xc="shipping-email-field"
    errorMessage={isTouched && error ? error : undefined}
    ref={refField}
    {...props}
  />
);

EmailField.propTypes = {
  error: PropTypes.string,
  label: PropTypes.string,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  isTouched: PropTypes.bool,
  refField: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default EmailField;
